document.addEventListener('DOMContentLoaded', function () {
  const taOverlay = document.querySelector('.ta-overlay');
  const taForm = document.querySelector('.ta-your-feedback');

  taOverlay.addEventListener('click', (e) => {
    e.preventDefault();
    if (!taOverlay.classList.contains('n-active')) {
      taOverlay.classList.add('n-active');
      taForm.focus();
    }
  });

  taForm.addEventListener("focusout", (e) => {
    if (taForm.value === '') taOverlay.classList.remove('n-active')
  });

  var domain = 'https://themagic5.com/tools/appconnect/nps.php';
  console.log("Window location: " + window.location);
  var url = new URL(window.location);
  var nps = url.searchParams.get("nps");
  var sku = url.searchParams.get("sku");
  var shopify_order_number = url.searchParams.get("shopify_order_number");
  var email = url.searchParams.get("email");
  var name = url.searchParams.get("name");
  console.log("Searchparams " + nps);
  function registerNPS() {
    var _img = document.getElementById('hhh');
    var _text = document.getElementById("goggletext");
    var url = domain + "?nps=" + nps + "&shopify_order_number=" + shopify_order_number + "&email=" + email + "&name=" + name;
    var newImg = new Image;
    console.log("I am sending the nps results to url " + url);
    newImg.onload = function () {
      // _img.src = this.src;
      console.log("NPS have been registered: " + nps + " Going to replace this url if the response i 9 or 10 (random between 3 review sites).");
      if (nps == '9' || nps == '10') {
        randomNumber = Math.floor(Math.random() * 2);
        var newurl = "";
        if (randomNumber == 0) {
          newurl = "http://www.reviews.io/store/landing_new_review?store=themagic5-com&user=" + name + "&order_id=" + shopify_order_number + "&email=" + email + "&products=" + sku + "&type=store_review,product_review";
        }
        if (randomNumber == 1) {
          newurl = "https://www.trustpilot.com/evaluate/themagic5.com?stars=5";
        }
        if (randomNumber == 2) {
          newurl = "https://g.page/r/CY4QHtU9EII_EB0/review";
        }
        console.log("Replacing your-feedback url with: " + newurl);
        window.location.replace(newurl);
      }
    }
    newImg.src = url;
    newImg.crossOrigin = "Anonymous";
  }

  const form = document.querySelector('#your-feedback-form');

  form.addEventListener('submit', (e) => {
    e.preventDefault();

    var _img = document.getElementById("sendButton");
    var _text = document.getElementById("textinput");
    var _buttontext = document.getElementById("buttontext");
    _img.crossOrigin = "Anonymous";
    var url = domain + "?nps=" + nps + "&text=" + _text.value + "&shopify_order_number=" + shopify_order_number + "&email=" + email + "&name=" + name;
    var newImg = new Image;
    newImg.onload = function () {
      _img.src = this.src;
      _buttontext.innerHTML = "THANK YOU !";
    }
    newImg.src = url;
    newImg.crossOrigin = "Anonymous";
  });
  
  console.log("Search " + window.location.search);
  registerNPS();
});